module.exports = __webpack_public_path__ + "img/No2.a39662e1.svg";